import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconFlagGe = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 512 512" size={size}>
      <g>
        <rect fill="#000000" height="99.6" width="512" y="106.7" />
        <rect fill="#D60000" height="99.6" width="512" y="206.2" />
        <rect fill="#F7C800" height="99.6" width="512" y="305.8" />
      </g>
    </BaseIcon>
  );
}

export default IconFlagGe;